module.exports = "<ng-container  *ngIf=\"eventObj\">\n<div class=\"container-fluid event-list\">\n    <ng-container *ngFor=\"let item of eventObj.data\">\n        <event-item\n            class=\"event-item-container\" \n            [event$]=\"item\" \n            [ngClass]=\"{'pull-right': (item | meta).identifier == 'next', 'pull-left':  (item | meta).identifier == 'previous'}\"\n        >\n        </event-item>\n    </ng-container>\n</div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/events/event-list/event-list.template.html
// module id = 771
// module chunks = 2